import React, { useState } from 'react'
import DataTable from './DataTable';
import SectionCard from './SectionCard';



const irrData = [
    {
        id: 1,
        sr: 1,
        product: "Fourwd",
        project: "Indore MMLP",
        underwritingCost: "327 Cr - Phase 1",
        currentCost: "360 Cr - Phase 1",
        projectIRR: "11.24%",
        equityIRR: "13.3%",
    },
    {
        id: 2,
        sr: 2,
        product: "Fourci",
        project: "Indore MMLP",
        underwritingCost: "327 Cr - Phase 1",
        currentCost: "360 Cr - Phase 1",
        projectIRR: "11.24%",
        equityIRR: "13.3%",
    },
    {
        id: 3,
        sr: 3,
        product: "Fourun",
        project: "Indore MMLP",
        underwritingCost: "-",
        currentCost: "-",
        projectIRR: "-",
        equityIRR: "-",
    },
    {
        id: 4,
        sr: 4,
        product: "WSA",
        project: "Indore MMLP",
        underwritingCost: "-",
        currentCost: "-",
        projectIRR: "-",
        equityIRR: "-",
    },
];

const IRRViewNew = () => {
    const columns = [
        { field: "sr", headerName: "#" },
        { field: "product", headerName: "Product" },
        { field: "project", headerName: "Project" },
        { field: "underwritingCost", headerName: "Total Project cost (INR Cr) (Underwriting)" },
        { field: "currentCost", headerName: "Total Project cost (INR Cr) (Current/Actual)" },
        { field: "projectIRR", headerName: "Project IRR (%)" },
        { field: "equityIRR", headerName: "Equity IRR (%)" },
    ];



    return (
        <>
            <SectionCard title="IRR View" description="Real-time Project & Equity IRR Comparison vs Underwriting Benchmarks">

            </SectionCard>
            <DataTable columns={columns} data={irrData} />
        </>
    );
}

export default IRRViewNew
